import React, { createContext, useContext } from "react";
import type { CreatorBrowsableUrlPrefs } from "../Utils/url/getCreatorPublicBaseUrl";

const CreatorBrowsableUrlPrefsContext = createContext<
  CreatorBrowsableUrlPrefs | undefined
>(undefined);

export function CreatorBrowsableUrlPrefsProvider({
  value,
  children,
}: {
  value: CreatorBrowsableUrlPrefs | undefined;
  children: React.ReactNode;
}) {
  return (
    <CreatorBrowsableUrlPrefsContext.Provider value={value}>
      {children}
    </CreatorBrowsableUrlPrefsContext.Provider>
  );
}

export function useCreatorBrowsableUrlPrefs(): CreatorBrowsableUrlPrefs | undefined {
  return useContext(CreatorBrowsableUrlPrefsContext);
}
